import { purpleLightGrey, purpleLightGreyHover } from '/b2b/common/colors';

import { PANEL_MODES } from '../../state/reducer';

export default (theme, { panelMode }, classes) => ({
    popoverPaper: {
        width: 400,
        display: 'flex',
        flexDirection: 'column',
        // The pop-up overlay is only ~600px tall, so cap the chats menu to fit
        // inside it; the full-height sidebar/fullscreen modes keep the taller cap.
        maxHeight: panelMode === PANEL_MODES.WIDGET ? 500 : 800,
    },
    popoverHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.spacing(1, 1, 0, 2),
        flexShrink: 0,
    },
    popoverTitle: {
        fontWeight: 600,
    },
    popoverHeaderActions: {
        display: 'flex',
        alignItems: 'center',
    },
    popoverTabs: {
        flexShrink: 0,
        minHeight: 44,
        '& .MuiTabs-flexContainer': {
            borderBottom: `1px solid ${theme.palette.divider}`,
        },
        '& .MuiTab-root': {
            minHeight: 44,
            textTransform: 'none',
            fontWeight: 500,
            fontSize: '0.8125rem',
            color: theme.palette.grey[600],
            '& svg': {
                fontSize: '1.125rem',
            },
            '&.Mui-selected': {
                color: theme.palette.primary.main,
                fontWeight: 600,
            },
        },
        '& .MuiTabs-indicator': {
            height: 2,
            borderRadius: 2,
        },
    },
    popoverTab: {
        gap: theme.spacing(0.75),
    },
    popoverSearch: {
        padding: theme.spacing(1.5, 2),
        borderBottom: `1px solid ${theme.palette.divider}`,
        flexShrink: 0,
    },
    popoverEmpty: {
        padding: theme.spacing(3, 2),
        textAlign: 'center',
    },
    popoverList: {
        flex: '1 1 auto',
        overflowY: 'auto',
    },
    loadMoreWrapper: {
        display: 'flex',
        justifyContent: 'center',
        padding: theme.spacing(0.5, 2),
        borderTop: `1px solid ${theme.palette.divider}`,
    },
    conversationItem: {
        borderBottom: `1px solid ${theme.palette.divider}`,
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
        },
        [`&:hover .${classes.deleteButton}`]: {
            opacity: 1,
        },
    },
    conversationItemActive: {
        backgroundColor: purpleLightGrey,
        '&:hover': {
            backgroundColor: purpleLightGreyHover,
        },
    },
    conversationTitleRow: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        minWidth: 0,
    },
    conversationTitle: {
        fontWeight: 600,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        flex: '1 1 auto',
        minWidth: 0,
    },
    sidebarChip: {
        flexShrink: 0,
    },
    conversationPreview: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
    },
    deleteButton: {
        opacity: 0,
        flexShrink: 0,
    },
});
